import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';

function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border/80 rounded-lg px-3 py-2 shadow-lg">
        <p className="text-xs text-muted-foreground">{label}</p>
        <p className="text-sm font-semibold tabular-nums">{payload[0].value} Points</p>
      </div>
    );
  }
  return null;
}

export function RiskTrendChart({ trendData = [] }) {
  if (!trendData || trendData.length === 0) return null;
  return (
    <Card className="bg-card border-border/80" data-testid="risk-score-trend-chart">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold">Risk Score Trend</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ width: '100%', height: 250, minWidth: 200 }}>
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={trendData} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
              <defs>
                <linearGradient id="scoreGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="hsl(188, 100%, 55%)" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="hsl(188, 100%, 55%)" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(222, 16%, 16%)" vertical={false} />
              <XAxis dataKey="date" tick={{ fontSize: 11, fill: 'hsl(215, 14%, 72%)' }} axisLine={false} tickLine={false} />
              <YAxis domain={[0, 100]} tick={{ fontSize: 11, fill: 'hsl(215, 14%, 72%)' }} axisLine={false} tickLine={false} />
              <Tooltip content={<CustomTooltip />} />
              <ReferenceLine y={25} stroke="hsl(142, 72%, 45%)" strokeDasharray="3 3" strokeOpacity={0.3} />
              <ReferenceLine y={50} stroke="hsl(45, 93%, 58%)" strokeDasharray="3 3" strokeOpacity={0.3} />
              <ReferenceLine y={75} stroke="hsl(0, 84%, 60%)" strokeDasharray="3 3" strokeOpacity={0.3} />
              <Area type="monotone" dataKey="score" stroke="hsl(188, 100%, 55%)" strokeWidth={2} fill="url(#scoreGradient)" dot={false} activeDot={{ r: 5, stroke: 'hsl(188, 100%, 55%)', strokeWidth: 2, fill: 'hsl(222, 34%, 5%)' }} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}

